import * as React from 'react'

import { useRecoilValue } from 'recoil'

import { Ids } from '../../../constants/Ids'
import { translate } from '../../../state/locale/selectors/translate'
import { Address } from '../../reusable/Address'
import styles from './Tenant.module.scss'
import { ITenantProps } from './Tenant.types'

export const Tenant = ({ data }: ITenantProps) => {
  const i18n = useRecoilValue(translate).rent

  return (
    <div className={styles.tenantWrapper}>
      <h2 className={styles.pageTitle} id={Ids.tenantApplication}>
        {data.applicationTitle}
      </h2>
      <p className={styles.paragraph}>{data.applicationDescription}</p>
      {Boolean(data.sections.length) &&
        data.sections.map((section) => {
          switch (section.__component) {
            case 'tenant.title':
              return <h3 className={styles.pageSubtitle}>{section.headerText}</h3>
            case 'tenant.list':
              return (
                <ul className={styles.list}>
                  {section.listItem.map((listItem) => {
                    switch (listItem.type) {
                      case 'bullet':
                        return <li className={styles.listIItem}>{listItem.label}</li>
                      case 'nested':
                        return <li className={styles.nested}>{listItem.label}</li>
                      case 'link':
                        return (
                          <li>
                            <a href={listItem.link} download={listItem.download}>
                              {listItem.label}
                            </a>
                          </li>
                        )
                      default:
                        return null
                    }
                  })}
                </ul>
              )
            default:
              return null
          }
        })}
      <div className={styles.tenantServiceWrapper} id={Ids.tenantService}>
        <div className={styles.copyWrapper}>
          <h2 className={styles.pageTitle}>{i18n.tenantServiceTitle}</h2>
          <p className={styles.paragraph}>{data.tenantService.description}</p>
        </div>
        <Address address={data.tenantService.address} />
        <p className={styles.paragraph} children={data.tenantService.officeHours} />
      </div>
    </div>
  )
}
